'use client';

import { EventBanner } from './event-banner';
import { MilestoneRewards } from './milestone-rewards';
import { useGetUserSoloEvents } from '@wwe-portal/web/providers/queries/rbe';
import { useTranslations } from 'next-intl';
import { SoloEventLeaderboard } from './solo-event-leaderboard';
import { EventItemLayout, EventListLayout } from './event-layout';
import { RBE_SECTIONS } from '@wwe-portal/web/utils/constants/rbe';
import { EventStatisticBadge } from './event-badge';

export const SoloEventSection = () => {
  const t = useTranslations();
  const {
    data: userSoloEvents,
    userProgressMap,
    soloEvents,
  } = useGetUserSoloEvents();

  return (
    <EventListLayout id={RBE_SECTIONS.SOLO_EVENT_SECTION}>
      {soloEvents?.map((event) => (
        <EventItemLayout
          key={event.portalEventId}
          id={String(event.portalEventId)}
          banner={
            <EventBanner
              eventData={event}
              userProgress={userProgressMap.get(event.portalEventId)}
              eventType={t('rbe.type.solo')}
              badge={
                userProgressMap.get(event.portalEventId)?.point != null ? (
                  <div className="flex items-center justify-end gap-2.5">
                    <EventStatisticBadge
                      point={
                        userProgressMap.get(event.portalEventId)?.point ?? 0
                      }
                      label={t('your_event_point')}
                    />
                  </div>
                ) : null
              }
            />
          }
          milestones={
            <MilestoneRewards
              eventData={event}
              userProgress={userSoloEvents?.find(
                (userEvent) => userEvent.portalEventId === event.portalEventId
              )}
            />
          }
          leaderboard={
            event.leaderboardId ? <SoloEventLeaderboard event={event} /> : null
          }
        />
      ))}
    </EventListLayout>
  );
};
